import { PageViewedTracker } from '@zenbusiness/application-commons-clickstream';
import Heading from '@zenbusiness/zui/Heading';
import PageContainer from '@zenbusiness/zui/PageContainer';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import { useLocation } from 'react-router-dom';

import { BankingOptionCards, PartnerFootnotes } from '#client/components/BankingOptions';
import useBankingOptionCards from '#client/hooks/useBankingOptionCards';

import BankingOptionsFaq from './components/BankingOptionsFaq';

import { BANKING_TRANSITION_PAGE_NAMES } from '../constants';

const OPTION_EVENTS = {
  appPageName: BANKING_TRANSITION_PAGE_NAMES.BANKING_OPTIONS,
  elementNames: {
    mercuryCta: 'banking_transition_mercury_get_started',
    bankOfAmericaOfferLink: 'banking_transition_bofa_offer_page_link',
    bankOfAmericaCta: 'banking_transition_bofa_contact_me',
    mercuryAgreementLink: 'banking_transition_mercury_agreement_link'
  }
};

/**
 * The only step in the Oct 1 transition flow: two partner offers, an FAQ, and the partner
 * disclosures. Choosing Bank of America does not end the flow, so the customer can still pick Mercury.
 * @returns {import('react').ReactElement} The step content
 */
export default function BankingOptionsStep() {
  const { pathname } = useLocation();
  const cards = useBankingOptionCards(OPTION_EVENTS);

  return (
    <PageContainer
      data-testid="banking-options-step"
      sx={{ display: 'flex', flexDirection: 'column', gap: 5, my: 0 }}
    >
      <PageViewedTracker
        appPageName={BANKING_TRANSITION_PAGE_NAMES.BANKING_OPTIONS}
        appSection="banking"
        experienceOrigin="dashboard"
        key={pathname}
      />

      <Stack sx={{ gap: 0.5 }}>
        <Heading
          color="primary"
          component="h1"
          size="xl"
        >
          Find the right bank account for your business
        </Heading>
        <Text
          color="secondary"
          size="md"
        >
          Compare your options and choose the account that best fits your business needs.
        </Text>
      </Stack>

      <BankingOptionCards cards={cards} />

      <BankingOptionsFaq />

      <PartnerFootnotes
        appPageName={OPTION_EVENTS.appPageName}
        elementName={OPTION_EVENTS.elementNames.mercuryAgreementLink}
      />
    </PageContainer>
  );
}
